import React from 'react';
import { useTranslation } from 'react-i18next';
import Link from '../../../Link';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  const handlePrivacyPolicyClick = () => {
    window.open('https://cpzone.in/pages/privacy.html', '_blank');
  };

  const handleTermsOfServiceClick = () => {
    window.open('https://cpzone.in/pages/terms.html', '_blank');
  };

  const handleContactClick = () => {
    window.open('https://cpzone.in/pages/contact.html', '_blank');
  };

  return (
    <footer className="content-footer footer bg-footer-theme">
      <div className="container-fluid">
        <div className="footer-container d-flex align-items-center justify-content-between py-4 flex-md-row flex-column">
          <div className="text-body mb-2 mb-md-0">
            © {new Date().getFullYear()} {t('layout.pageTexts.private.footer.copyright')}
          </div>
          <div className="d-inline-block">
            <Link
              className="footer-link me-4 cursor-pointer"
              text={t('layout.pageTexts.private.footer.privacyPolicy')}
              onClick={handlePrivacyPolicyClick}
            />
            <Link
              className="footer-link me-4 cursor-pointer"
              text={t('layout.pageTexts.private.footer.termsOfService')}
              onClick={handleTermsOfServiceClick}
            />
            <Link
              className="footer-link cursor-pointer"
              text={t('layout.pageTexts.private.footer.contact')}
              onClick={handleContactClick}
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
